import apiClient from './client'
import type {
  LoginRequest,
  LoginResponse,
  LoginResult,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  UpdateProfileRequest,
  User,
} from '../types/auth'

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResult>('/auth/login', data).then((r) => r.data),

  verifyTwoFactor: (data: { mfaToken: string; code: string }) =>
    apiClient.post<LoginResponse>('/auth/login/verify-2fa', data).then((r) => r.data),

  refresh: (refreshToken: string) =>
    apiClient.post<LoginResponse>('/auth/refresh', { refreshToken }).then((r) => r.data),

  logout: (accessToken?: string) =>
    apiClient.post('/auth/logout', undefined, accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : undefined),

  forgotPassword: (data: ForgotPasswordRequest) =>
    apiClient.post('/auth/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest) =>
    apiClient.post('/auth/reset-password', data),

  getMe: () =>
    apiClient.get<{ user: User; permissions: string[] }>('/auth/me').then((r) => r.data),

  updateProfile: (data: UpdateProfileRequest) =>
    apiClient.put<User>('/auth/me', data).then((r) => r.data),

  changePassword: (data: ChangePasswordRequest) =>
    apiClient.put('/auth/change-password', data),

  getPermissions: () =>
    apiClient.get<string[]>('/auth/permissions').then((r) => r.data),
}
